<div class="side-menu custom-scrollbar" [class.collapsed]="isMobileScreen ? false : isSidebarCollapsed">
  <header>
    <div class="logo shine shiny">
      <img [src]="logoUrl" alt="logo" />
    </div>
    <div class="user">
      <p>{{ currentAccount.title }}</p>
    </div>
  </header>
  <main>
    <nav class="main-menu">
      @for (navGroup of navigationModel.navigationGroups; track navGroup.title) {
        <section>
          <div *ngIf="navGroup.title" class="menu-header">{{ navGroup.title }}</div>
          <ul>
            @for (navItem of navGroup.items; track navItem.name) {
              <li class="menu-item">
                <a
                  [id]="navItem.idAttr"
                  [routerLink]="[navItem.url]"
                  routerLinkActive="active-item"
                  [target]="navItem.target"
                >
                  <span class="menu-icon">
                    <i class="material-symbols-outlined">{{ navItem.icon }}</i>
                  </span>
                  <span class="menu-title">{{ navItem.name }}</span>
                </a>
              </li>
            }
          </ul>
        </section>
      }
    </nav>
    <nav class="extra-menu">
      <section>
        <ul>
          <li class="menu-item" [class.user-avatar]="!isSidebarCollapsed">
            <a
              (click)="$event.stopPropagation()"
              ngDropdown
              [templateRef]="accountOptionsTemplate"
              [closeUponSelection]="true"
            >
              <app-employee-avatar [employee]="currentEmployee" [size]="avatarSize"></app-employee-avatar>
              <span class="menu-title">Profile</span>
            </a>
          </li>
          <li class="menu-item">
            <a
              [routerLink]="':accountId/hub/document-manager' | url" 
              (click)="collapseSidebarOnMenuItemSelect()"
              routerLinkActive="active-item"
            >

              <span class="menu-icon">
                <i class="material-symbols-outlined">folder</i>
              </span>
              <span class="menu-title">{{ T.settings.document_manager | translate }}</span>
            </a>
          </li>
          <li class="menu-item help-center">
            <a
              (click)="$event.stopPropagation()"
              ngDropdown
              [templateRef]="supportTemplate"
              [closeUponSelection]="true">

              <span class="menu-icon">
                <i class="material-symbols-outlined">help</i>
              </span>
              <span class="menu-title">{{ T.common.help | translate }}</span>
            </a>
          </li>
        </ul>
      </section>
    </nav>
  </main>
  <footer>
    <div class="footer-content">
      <div class="logo-container shine">
        <img class="wetrack-logo" [src]="brandingUrl" alt="" />
      </div>
    </div>
  </footer>
</div>>

<ng-template #accountOptionsTemplate>
  <div class="more-info-popup-container">
    <div class="more-info-popup-header">{{ currentEmployee.firstName }} {{ currentEmployee.surname }}</div>
    <div class="more-info-popup-body">
      <div
        class="more-info-popup-row"
        [routerLink]="':accountId/settings/preferences' | url"
        (click)="collapseSidebarOnMenuItemSelect()"
      >
        <i class="material-symbols-outlined">account_circle</i>
        <span>{{ T.settings.my_preferences.my_preferences_text | translate }}</span>
      </div>
      <div class="more-info-popup-row" (click)="logout()">
        <i class="material-symbols-outlined">exit_to_app</i> <span>{{ T.settings.logout | translate }}</span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #supportTemplate>
</ng-template>
